/**
 *   Created by FANGlh on 2019/1/14 18:13.
 *   Desc: 学生请假详情
 */

import React, {Component} from 'react';
import "./LeaveDetail.css";
import {connect} from 'react-redux';
import {fetchPost, fetchGet, fetchGetNoSession} from '../../../utils/fetchRequest';
import {API, _baseURL} from '../../../configs/api.config';
import ImageGrid from "../../../components/image/ImageGrid";
import {Button, Icon, Input, List} from 'antd';
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import LazyLoad from 'react-lazyload';
import ImagesViewer from '../../../components/imagesVIewer/index';
import {Toast} from 'antd-mobile';
import {getIntValue, getStrValue, isObjEmpty,getSearchParams} from "../../../utils/common";
import {saveListState} from "../../../redux/actions/listState";

class LeaveDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemdetail: {},
            pictureList: [],
            index: null,
            role: 'parent',
            previewImage: '',
            previewVisible: false,
            messageContent: null,
            isShowFoot: true,

        }
    }

    componentWillMount() {
        document.title = '学生请假'
    }

    componentDidMount() {
        this.searchParams = getSearchParams(this.props.location.search)

        this.teacherId = this.props.userInfo.user.userFunId
        if (this.searchParams && this.searchParams.teacherId) {
            this.teacherId = this.searchParams.teacherId
        }

        let lvId = this.props.match.params.lvId
        let role = this.props.match.params.role
        let isshowfoot = true

        if (role == 'teacher') {
            isshowfoot = true
        } else {
            isshowfoot = false
        }
        this.setState({
            isShowFoot: isshowfoot
        })

        console.log("lvId", lvId)
        if (!isObjEmpty(lvId)) {
            this.getleaveDetail(lvId)
        }
    }

    render() {
        const {itemdetail} = this.state
        const {pictureList} = this.state
        let pictureItems = []
        let pictureUrls = []
        for (let i = 0; i < pictureList.length; i++) {
            const pictureUrl = pictureList[i]
            pictureUrls.push(pictureUrl)
            if (!isObjEmpty(pictureUrl)) {
                pictureItems.push(
                    i > 20 ?
                        <LazyLoad throttle={200} height={300} once overflow>
                            <CSSTransition
                                timeout={2000}
                                classNames='fade'
                                appear={true}
                                key={i}>
                                <div className='pictureItem'>
                                    <img src={pictureUrl} onClick={this.handlePreview.bind(this, pictureUrl, i)}/>
                                </div>
                            </CSSTransition>
                        </LazyLoad> :
                        <div className='pictureItem'>
                            <img src={pictureUrl} onClick={this.handlePreview.bind(this, pictureUrl, i)}/>
                        </div>
                )
            }
        }
        return (
            <div className="class-page-layout">
                <div className="top_header">
                    <div className="common-flex-row">
                        <div id="global_page_title" style={{fontSize: 15, color: "#333333"}}>  {itemdetail.title}</div>
                        <div className="item_flex_1  flex_row_right margin_left_right_10">
                            {this.state.role === "parent" ? ("") : (<div>
                                {itemdetail.leaveMessages.length == 0 ?
                                    <div style={{fontSize: 12, color: "#FA5200"}}>未查阅</div> :
                                    <div style={{fontSize: 12, color: "##686868"}}>已查阅</div>}
                            </div>)}
                        </div>
                    </div>
                    <div className="leave_reason">
                        <div style={{fontSize: 12, color: "#666666",width:'20%'}}>请假时间：</div>
                        <div style={{fontSize: 12, color: "#666666",width:'80%'}}>{itemdetail.startTime}—{itemdetail.endTime}</div>
                    </div>
                    <div  style={{marginTop: 10}} className="leave_reason">
                        <div style={{fontSize: 12, color: "#666666",width:'20%'}}>请假事由：</div>
                        <div style={{fontSize: 12, color: "#333333",width:'80%',wordWrap:'break-word'}}>{itemdetail.content}</div>
                    </div>
                    <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                        <div style={{flex: '1', overflow: 'scroll', padding: '5px', webkitOverflowScrolling: 'touch'}}>
                            <TransitionGroup>
                                {pictureItems}
                            </TransitionGroup>
                        </div>
                    </div>

                    <div style={{fontSize: 15, color: "#666666", marginTop: 10,marginLeft:15}}>回复：</div>
                    <div className="comhline_sty1" style={{marginTop: 5}}></div>
                </div>

                <div className='homework-detail-leave-layout'
                     style={{paddingBottom: this.state.role === "teacher" ? '0' : '50px'}}>
                    {!itemdetail.leaveMessages ? '' :
                        <List
                            dataSource={itemdetail.leaveMessages}
                            renderItem={item => (
                                    <div style={{paddingTop:5,paddingBottom:5}}>
                                        <span className=" margin_left_right_20"
                                              style={{color: '#333333',wordWrap:'break-word',fontSize:14}}>{item.replyContent}</span>
                                    </div>
                            )}
                        />
                    }
                </div>

                {
                    this.state.isShowFoot == true ?
                        <div className="footer flex padding_10" style={{background: '#F2F2F2', alignItems: 'center'}}>
                            <img src={require('imgs/ic_edit.png')} width={28} height={28}/>
                            <input ref={ref => this.input_content = ref} value={this.state.messageContent}
                                   onChange={this.onChangeMessage} placeholder="留言"
                                   className='homework-detail-leave-input'></input>
                            <span onClick={this.onMessageSend} className="homework-detail-leave-send">发送</span>
                        </div> : ''
                }

                {this.state.previewVisible ?
                    <ImagesViewer onClose={this.handleCancel} urls={pictureUrls}
                                  index={this.state.previewIndex}
                                  needPoint={pictureUrls.length <= 9}/> : ""}
            </div>
        )
    }

    onMessageSend = () => {
        if (isObjEmpty(this.state.messageContent)) {
            Toast.fail("请输入回复内容")
            return;
        }
        Toast.loading('回复中...', 0)

        const params = {
            replyTitle: '请假单回复',
            replyContent: this.state.messageContent,
            teacherId: this.teacherId,
            lvId: this.state.itemdetail.lvId,

        }
        console.log('params', params)
        fetchPost(API.leaveReply,
            {
                leaveReplyString: JSON.stringify(params)
            }, {}).then((response) => {
            console.log("response:" + JSON.stringify(response));
            if (response.success) {
                Toast.hide()
                Toast.info("回复成功！");

                // this.backTask = setTimeout(() => {
                //     this.props.history.goBack();
                // }, 2000)

                if (this.props.listState && !isObjEmpty(this.props.listState.listData)) {
                    this.props.listState.listData[this.props.listState.itemIndex].leaveMessages = this.state.messageContent
                    saveListState({
                        listData: this.props.listState.listData,
                    })()
                }
                this.setState({
                    messageContent: ""
                })
                this.getleaveDetail(this.state.itemdetail.lvId)
            }
        }).catch((error) => {
            Toast.fail(error)
            Toast.hide()
            console.log("error:" + JSON.stringify(error));
        })
    }
    getleaveDetail = (lvid) => {
        fetchGet(API.leaveDetail, {
            lvId: lvid,
        }).then((response) => {
            if (response.success && !isObjEmpty(response.data)) {
                let model = {
                    lvId: response.data.lvId,
                    title: response.data.lvTitle,
                    endTime: response.data.endDate,
                    startTime: response.data.startDate,
                    content: response.data.lvDetails,
                    enclosure: response.data.enclosure,
                    leaveMessages: response.data.oaLeaveReplyDOS
                };
                this.setState({
                    itemdetail: model
                }, function () {
                    console.log("itemdetail", this.state.itemdetail)
                    let pictureList = [];
                    for (let i = 0; i < this.state.itemdetail.enclosure.length; i++) {
                        pictureList.push(this.state.itemdetail.enclosure[i]);
                    }
                    this.setState({
                        pictureList: pictureList
                    })
                })
            }
        }).catch((error) => {
            console.log("error:", JSON.stringify(error));
        })
    }
    onChangeMessage = (event) => {
        let msg = event.target.value;
        this.setState({
            messageContent: msg
        })
    }
    handleCancel = () => this.setState({previewVisible: false})
    handlePreview = (url, index) => {
        this.setState({
            previewImage: url,
            previewVisible: true,
            previewIndex: index
        });
    }
}

let mapStateToProps = (state) => ({
    listState: {...state.redListState},
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LeaveDetail)
